import Footer from "components/VerticalLayout/Footer";
import React from "react";
import { Container, Row, Col, Card } from "reactstrap";

const Aboutus = () => {
    return (
        <React.Fragment>
            {/* Hero Section */}
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <div
                style={{
                    background: "linear-gradient(rgba(0,0,0,0.9), rgba(0,0,0,0.9))",
                    color: "#fff",
                    textAlign: "center",
                    padding: "80px 20px",
                    minHeight: "200px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <h1 style={{ fontSize: "2.5rem", fontWeight: "bold", margin: 0 }}>
                    About Us
                </h1>
            </div>

            {/* About Content */}
            <Container className="py-5 text-white">
                <Row>
                    <Col md={12}>
                        {/* Our Story */}
                        <h2 className="mb-3">Our Story</h2>
                        <Card className="p-4 shadow-sm my-3 bg-dark border-0 text-white">
                            <p>
                                In Vadodara’s real estate market, buyers and sellers often face
                                challenges — from lack of transparency to difficulty in finding
                                verified listings. We saw how overwhelming and confusing this
                                process can be.
                            </p>
                            <p>
                                That’s why <strong>aiinrealestate.in</strong> was born. Our
                                inspiration was simple: use technology and AI to bring clarity,
                                trust, and simplicity to real estate decisions.
                            </p>
                            <p>
                                Our vision is to become Vadodara’s most trusted and efficient
                                real estate platform, empowering individuals with accurate
                                insights and verified property options.
                            </p>
                        </Card>

                        {/* Mission */}
                        <h2 className="mt-5 mb-3">Our Mission</h2>
                        <Card className="p-4 shadow-sm my-3 bg-dark border-0 text-white">
                            <p>
                                Our mission is to simplify the real estate journey in Vadodara
                                by providing a technology-driven platform that offers verified
                                listings, data-backed insights, and personalized guidance for
                                buying, selling, and renting properties.
                            </p>
                        </Card>

                        {/* Values */}
                        <h2 className="mt-5 mb-3">Our Values</h2>
                        <Card className="p-4 shadow-sm my-3 bg-dark border-0 text-white">
                            <ul>
                                <li>
                                    <strong>Transparency:</strong> We ensure every listing is
                                    accurate and verified so you can trust what you see.
                                </li>
                                <li>
                                    <strong>Integrity:</strong> We operate with ethics and put
                                    your interests first.
                                </li>
                                <li>
                                    <strong>Innovation:</strong> We continuously use technology to
                                    improve your experience.
                                </li>
                                <li>
                                    <strong>Customer-Centricity:</strong> Your satisfaction is our
                                    top priority — we are here to support you at every step.
                                </li>
                            </ul>
                        </Card>

                        {/* Team */}
                        <h2 className="mt-5 mb-3">The Team</h2>
                        <Card className="p-4 shadow-sm my-3 bg-dark border-0 text-white">
                            <p>
                                We’re a passionate team of real estate enthusiasts, tech
                                experts, and local market specialists. Together, we’re
                                committed to transforming how Vadodara experiences real estate —
                                making it more transparent, accessible, and customer-focused.
                            </p>
                        </Card>
                    </Col>
                </Row>
            </Container>

            {/* Footer */}
            <Footer />
        </React.Fragment>
    );
};

export default Aboutus;
